// extracted by mini-css-extract-plugin
export default {"tinyHeight":"ATMInput_tinyHeight__AMyin"};